import { decode } from "blurhash";

const updateCardsBlurHash = function() {
    const hashes = document.querySelectorAll('[data-blur-hash]')
    hashes.forEach(item => {

        if(item.dataset.blurHash == '') {
            //img.classList.remove('opacity-0');
        } else {
            const blurHash = item.dataset.blurHash;

            const pixels = decode(blurHash, 32, 32);
            const canvas = document.createElement("canvas");
            canvas.width = 32;
            canvas.height = 32;
            const ctx = canvas.getContext("2d");
            canvas.style.width = '100%';
            canvas.style.height = '100%';
            canvas.style.position = 'absolute';
            canvas.style.top = '0';
            canvas.style.bottom = '0';
            canvas.style.left = '0';
            canvas.style.right = '0';
            const imageData = ctx.createImageData(32, 32);
            imageData.data.set(pixels);
            ctx.putImageData(imageData, 0, 0);
            item.appendChild(canvas);
        }
    });

    window.addEventListener('load', () => {
        hashes.forEach(item => {
            // remove the fade from the image, and add to the canvas object
            item.firstElementChild.classList.remove('fade');
            item.lastElementChild.classList.add('fade');
        });
    });

}

updateCardsBlurHash();
